import { useCallback } from 'react';

import type { EditorView } from '@atlaskit/editor-prosemirror/view';
import type { AiManagedObject } from '@atlassian/ai-managed-objects/types';

import { executeAiManagedObject, type ExecuteAiManagedObjectArgs } from './executeAiManagedObject';

type UseAiManagedExecutionArgs = {
	editorView: EditorView;
};

type UseAiManagedExecutionResult = {
	executeAiManagedObject: (args: ExecuteAiManagedObjectArgs) => Promise<AiManagedObject | null>;
};

export const useAiManagedExecution = ({
	editorView,
}: UseAiManagedExecutionArgs): UseAiManagedExecutionResult => {
	const executeAiManagedObjectCallback = useCallback(
		(args: ExecuteAiManagedObjectArgs): Promise<AiManagedObject | null> =>
			executeAiManagedObject({ ...args, editorView }),
		[editorView],
	);

	return { executeAiManagedObject: executeAiManagedObjectCallback };
};
